/* eslint-disable react-hooks/exhaustive-deps */
import React, { memo, useMemo, useState } from 'react'
import useCarouselBehaviour from '../../hooks/useCarouselBehaviour/useCarouselBehaviour'
import ElementPaginator from '../elementPaginator/ElementPaginator'
import './CarouselPersona.scss'
const rootClassName = 'carousel-persona'

interface CarouselPersonaProps {
  personas?: {
    imgUrl: string
    name: string
    description: string
  }[]
}

function CarouselPersona(props: CarouselPersonaProps) {
  const [atual, setAtual] = useState<number>(0)

  const personas = useMemo(() => {
    return props.personas!?.map((persona, index: number) => {
      return (
        <div className={`${rootClassName}-persona`} key={index}>
          <div
            className={`${rootClassName}-image`}
            style={{ backgroundImage: `url(${persona.imgUrl})` }}
          />
          <div className={`${rootClassName}-name`}>{persona.name}</div>
          <div className={`${rootClassName}-description nunito`}>
            {persona.description}
          </div>
        </div>
      )
    })
  }, [props.personas])

  const [CarouselBehaviour, handleChange] = useCarouselBehaviour({
    atual,
    setAtual,
    slides: personas
  })
  return (
    <div className={rootClassName}>
      <div className={`${rootClassName}-personas`}>{personas}</div>
      <div className={`${rootClassName}-carousel`}>
        {CarouselBehaviour}
        <div className={`${rootClassName}-paginator`}>
          <ElementPaginator
            infinite
            size={props.personas?.length || 0}
            atual={atual + 1}
            onChange={(newAtual) => {
              handleChange(newAtual - 1, false)
            }}
          />
        </div>
      </div>
    </div>
  )
}

export default memo(CarouselPersona)
